export function projectList(root = document) {
  root.querySelectorAll("[data-project-list]").forEach((list) => {
    if (list.__projectListInitialized) return;
    list.__projectListInitialized = true;

    const buttons = list.querySelectorAll("[data-filter]");
    const items = list.querySelectorAll("[data-project-type]");
    const count = list.querySelector("[data-project-count]");
    const empty = list.querySelector("[data-project-empty]");
    const template =
      list.dataset.countTemplate || "Showing {visible} of {total} projects";

    const applyFilter = (value) => {
      let visible = 0;

      items.forEach((item) => {
        const types = item.dataset.projectType.split(/\s+/);
        const show = value === "all" || types.includes(value);
        item.hidden = !show;
        if (show) visible++;
      });

      buttons.forEach((button) => {
        button.setAttribute(
          "aria-pressed",
          String(button.dataset.filter === value),
        );
      });

      if (count) {
        count.textContent = template
          .replace("{visible}", visible)
          .replace("{total}", items.length);
      }
      if (empty) empty.classList.toggle("hidden", visible > 0);
    };

    const grid = list.querySelector("[data-project-items]");
    const FADE_MS = 200;
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    let fadeTimer;
    let current = "all";

    // Fade the grid out, swap the visible cards, then fade back in
    const changeFilter = (value) => {
      if (value === current) return;
      current = value;

      buttons.forEach((button) => {
        button.setAttribute(
          "aria-pressed",
          String(button.dataset.filter === value),
        );
      });

      clearTimeout(fadeTimer);
      if (!grid || reduceMotion.matches) {
        applyFilter(value);
        return;
      }

      grid.classList.add("is-fading");
      fadeTimer = setTimeout(() => {
        applyFilter(value);
        grid.classList.remove("is-fading");
      }, FADE_MS);
    };

    buttons.forEach((button) => {
      button.addEventListener("click", () => changeFilter(button.dataset.filter));
    });
  });
}
